import React from 'react';
import classNames from 'classnames';
import { Button } from 'ncoded-component-library';
import XIcon from 'icons/X.icon';

import './ActiveFilterSortPill.styles.scss';

type ActiveFilterSortPillProps = {
  className?: string;
  label: string;
  onRemove: () => void;
};

const ActiveFilterSortPill: React.FC<ActiveFilterSortPillProps> = (props) => {
  const { children, className, label, onRemove } = props;

  const classes = classNames('active-filter-sort-pill', className);

  return (
    <div className={classes}>
      <span>{label}</span>

      {children}

      <Button
        className="active-filter-sort-pill__remove"
        variant="icon"
        icon={XIcon}
        onClick={onRemove}
      />
    </div>
  );
};

export default ActiveFilterSortPill;
